import React from 'react';
const Payment = () => <div className="p-8"><h1 className="text-2xl font-bold">Payment Page</h1></div>;
export default Payment; 